/** Build terminal-style lines from device-agent SSH SSE events (shared by NeoAssistant + Chat Assistant). */

export const applyTerminalChunk = (
  lines: string[],
  chunk: string,
  startOnNewLine: boolean
): string[] => {
  const nextLines = [...lines];
  if (startOnNewLine || nextLines.length === 0) {
    nextLines.push("");
  }

  let currentLine = nextLines.pop() ?? "";
  let cursor = currentLine.length;
  for (const char of chunk) {
    if (char === "\r") {
      cursor = 0;
      continue;
    }
    if (char === "\n") {
      nextLines.push(currentLine);
      currentLine = "";
      cursor = 0;
      continue;
    }
    if (cursor >= currentLine.length) {
      currentLine += char;
    } else {
      currentLine = `${currentLine.slice(0, cursor)}${char}${currentLine.slice(cursor + 1)}`;
    }
    cursor += 1;
  }

  nextLines.push(currentLine);
  return nextLines;
};

export const buildTerminalLines = (sshEvents: any[]): string[] => {
  const lines: string[] = [];
  let startOnNewLine = false;

  for (const event of sshEvents || []) {
    const eventType = String(event?.event_type || "").toUpperCase();
    if (eventType === "SESSION_OPENED") {
      lines.push(`[session opened: ${event.os_type || "mac"}/${event.shell_type || "bash"}]`);
      startOnNewLine = true;
      continue;
    }
    if (eventType === "SESSION_OPEN_FAILED") {
      lines.push(`[session open failed: ${event.reason || "unknown"}]`);
      startOnNewLine = true;
      continue;
    }
    if (eventType === "COMMAND_STARTED" && event.command_text) {
      lines.push(`$ ${event.command_text}`);
      startOnNewLine = true;
      continue;
    }
    if ((eventType === "STDOUT" || eventType === "STDERR") && event.chunk) {
      const chunk = String(event.chunk);
      const next = applyTerminalChunk(lines, chunk, startOnNewLine);
      lines.splice(0, lines.length, ...next);
      startOnNewLine = false;
      continue;
    }
    if (eventType === "SESSION_CLOSED") {
      lines.push(`[session closed: ${event.reason || "unknown"}]`);
      startOnNewLine = true;
      continue;
    }
    if (eventType === "SESSION_ERROR") {
      lines.push(`[session error: ${event.reason || "unknown"}]`);
      startOnNewLine = true;
    }
  }

  return lines;
};
